import React from 'react';

import { Nullable } from '@clearverify/types';

import { UserStatus, useVerifierStaffListQuery, VerifierStaffWhere } from 'src/api';
import { BusinessRole } from 'src/constants/user';

export const useCheckVerifierAdmins = (verifierId: Nullable<string>) => {
  const filterByVerifierId: VerifierStaffWhere = React.useMemo(
    () => ({
      verifierId: { equals: verifierId },
      user: { status: { equals: UserStatus.Active } },
      role: { equals: BusinessRole.VerifierAdmin },
    }),
    [verifierId],
  );

  const { data, loading, refetch } = useVerifierStaffListQuery({
    variables: {
      filter: filterByVerifierId,
    },
    notifyOnNetworkStatusChange: true,
  });

  const isDisabled = data?.verifierStaffCount === 0;

  return {
    isDisabled,
    loading,
    refetch,
  };
};
